export const dbName = 'CityDataDB';
export const storeName = 'addresses';
export const adminCredentials = {
  username: 'admin',
  password: 'password123', // Replace with a secure validation mechanism
};
